import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/Profile/ProfileSidebar/profileSidebar.container"
    ).then((module) => ({
        default: module.ProfileSidebarContainer
    }))
);
